import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./slices/auth-slice";

const store = configureStore({
  // We can use the reducer directly or we can use the slice reducer
  // It changes the way we import the reducers
  reducer: {
    auth: authReducer,
  },
  //False serialize the state
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
